export function FoodFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M13.038 2.725A1 1 0 0114 2h2a1 1 0 010 2h-1.246l-.571 2h.429a3 3 0 012.953 3.527l-.468 2.625A4.003 4.003 0 0016 12h-2a4 4 0 00-4 4c0 .364.097.706.267 1-.17.294-.267.636-.267 1a4 4 0 002.239 3.592c-.45.262-.969.408-1.51.408h-2.13a3 3 0 01-2.974-2.608l-1.318-10A3 3 0 017.28 6h4.822l.935-3.275z"
      ></path>
      <path fill="currentColor" d="M16 14a2 2 0 012 2h-6a2 2 0 012-2h2zM14 20a2 2 0 01-2-2h6a2 2 0 01-2 2h-2z"></path>
    </svg>
  );
}
